var tbeData = {};
jQuery(document).ready(function() {

  fetch(`${tbe.app_url}/api/getInfo?pid=${tbe.product_id}`)
    .then((res) => res.json())
    .then((res) => {
      tbeData = res;
    });

  setTimeout(() => {
    jQuery('#tbe-form-wrapper .element').each(function() {
      var labelText = jQuery(this).find('label').not('.option').text();
      labelText = labelText.replace(/[\*:]|\s+$/g, '').trim();
  
      jQuery(this).find('input').attr('placeholder', labelText);
  
      jQuery(this).find('select').prepend(`<option value="" selected disabled hidden>${labelText}</option>`);
    });
  }, 2000);

  jQuery(".book-continue").on("click", function() {
    var variant_title = meta.product.variants.filter((variant) => {
      return variant.id == jQuery(".shopify-product-form [name=id]").val()
    })[0].name;
    jQuery("[data-variant-title]").val(variant_title);
    var variant_option = meta.product.variants.filter((variant) => {
      return variant.id == jQuery(".shopify-product-form [name=id]").val()
    })[0].public_title;
    var persons = variant_option.indexOf("/") > -1 ? 1 : parseInt(variant_option);
    persons = isNaN(persons) ? 1 : persons;

    let dt = new Date(jQuery("[data-datetime-format]").val());
    var newdt = dt.getDate() + '/' + (dt.getMonth() + 1) + '/' + dt.getFullYear() + ' ' + dt.toLocaleTimeString().replace(/(.*)\D\d+/, '$1');

    const quantityVariant = jQuery('[data-variant-quantity]')
    
    const zoneVariantTitle = jQuery('[data-zone-variant-title]').val()
    const subUrbSelect = jQuery('[data-suburb-select]').val()
    let postalCode = '';

    if(subUrbSelect) {
        postalCode = subUrbSelect.split(',')[0];
    }

    if (postalCode) {
        jQuery('input[name="properties[Postcode]"]').val(postalCode);
    }

    var info_html = '';

    info_html += `<div class="c-booking-drawer__course">`
    info_html += `<h4 class="o-subheading">
                    <span class="c-booking-drawer__label">Course:</span>
                    <span data-booking-course>${variant_title}</span>
                  </h4>
                  
                  <h4 class="o-subheading c-booking-form__locations">
                    <span class="c-booking-drawer__label">Location: </span>
                    <span data-booking-location>${subUrbSelect}, ${zoneVariantTitle}</span>
                  </h4>

                  <h4 class="o-subheading">
                    <span class="c-booking-drawer__label">Date: </span>
                    <span data-booking-date>${ newdt }</span>
                  </h4>

                  <h4 class="o-subheading">
                    <span class="c-booking-drawer__label">Duration: </span>
                    <span data-booking-duration> ${tbeData.duration} mins</span>
                  </h4>
                  `
    if (quantityVariant) {
      info_html += `
        <h4 class="o-subheading c-booking-form__tickets">
          <span class="c-booking-drawer__label">Number of tickets: </span>
          <span data-booking-duration> ${quantityVariant.val()}</span>
        </h4>
      `
    }
    info_html += `</div>`;

    document.getElementById("tbe-info-wrapper").innerHTML = info_html;
  })
})